import { cx, styled } from "simplydo/react/styled";

import type { ListContentProps } from "./List.types";

const ContentEl = styled.div`
  display: inline-block;
  vertical-align: middle;

  &.is-floated-right {
    float: right;
  }

  &.is-floated-left {
    float: left;
  }
`;

const ListContentComponent = (props: ListContentProps) => {
  const { floated, children, className, style } = props;
  return (
    <ContentEl
      className={cx(
        floated === "right" && "is-floated-right",
        floated === "left" && "is-floated-left",
        className,
      )}
      style={style}
    >
      {children}
    </ContentEl>
  );
};

export const ListContent = styled(ListContentComponent)``;
